import View from "../account/views/Dashboard";
import components from "./components.js";
components.define("js-dashboard-page", View);